export const queryPresets = {
  people: {
    title: "Explore people",
    sql: `SELECT p.display_name, c.name AS company, CASE WHEN p.overrides ? 'location' THEN p.overrides->>'location' ELSE l.name END AS location, i.handle, i.url, i.profile
FROM app.people p
LEFT JOIN app.companies c ON c.id=p.company_id
LEFT JOIN app.locations l ON l.id=p.location_id
LEFT JOIN app.identities i ON i.id=p.primary_identity_id
ORDER BY p.last_seen_at DESC
LIMIT 100`,
  },
  issues: {
    title: "Issue activity",
    sql: `SELECT r.title AS repository,a.type_key,a.title,a.body,a.occurred_at,a.observed_at,a.url
FROM app.signals a
LEFT JOIN app.resources r ON r.id=a.scope_resource_id
WHERE app.signal_record_kind(a.type_key) = 'issue'
ORDER BY a.observed_at DESC
LIMIT 100`,
  },
  daily: {
    title: "Daily activity",
    sql: `SELECT (observed_at AT TIME ZONE 'UTC')::date AS day, type_key AS signal, count(*)
FROM app.signals
WHERE origin = 'event'
GROUP BY 1,2
ORDER BY 1 DESC,3 DESC`,
  },
  stars: {
    title: "Star observations",
    sql: `SELECT r.title AS repository,i.handle,a.occurred_at,a.observed_at,(a.origin <> 'event')
FROM app.signals a
LEFT JOIN app.identities i ON i.id=a.identity_id
LEFT JOIN app.resources r ON r.id=a.scope_resource_id
WHERE a.type_key IN ('github.star','github.repository.starred','github.repository.star_observed')
ORDER BY a.observed_at DESC`,
  },
  roster: {
    title: "Current stargazers",
    sql: `SELECT r.title AS repository,i.handle,i.url,s.first_seen_at,s.last_seen_at
FROM app.relationships s
JOIN app.identities i ON i.id=s.identity_id
JOIN app.resources r ON r.id=s.resource_id
WHERE s.kind='star' AND s.active
ORDER BY s.first_seen_at DESC`,
  },
};
